"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var fleet_const_1 = require("./fleet.const");
/**
 * FleetService
 * @class
 */
var FleetService = /** @class */ (function () {
    function FleetService() {
    }
    /**
     * Returns a vehicle details for a given `vehicleId`
     * @param vehicleId {string}
     * @returns Vehicle
     */
    FleetService.prototype.getVehicleDetail = function (vehicleId) {
        var url = fleet_const_1.FLEET_ENDPOINT.getVehicleDetail.replace('{{vehicleId}}', vehicleId);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a vehicle overvier for a given `uuid`
     * @param vehicleId {string}
     * @returns Vehicle
     */
    FleetService.prototype.getVehicleOverview = function (vehicleId) {
        var url = fleet_const_1.FLEET_ENDPOINT.getVehicleOverview.replace('{{vehicleId}}', vehicleId);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a vehicle categories for a given `uuid`
     * @param operator {string} interpolated to `csOperatorUuid`
     * @returns
     */
    FleetService.prototype.getVehicleCategories = function (csOperatorUuid) {
        var url = fleet_const_1.FLEET_ENDPOINT.getVehicleCategories.replace('{{csOperatorUuid}}', csOperatorUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Creates a new vehicle when valid `data` (vehicle) object is provided
     * @param data <Vehicle>
     * @returns
     */
    FleetService.prototype.postVehicle = function (data) {
        var url = fleet_const_1.FLEET_ENDPOINT.postVehicle;
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    return FleetService;
}());
/**
 * FleetService Class Instance
 * @namespace
 */
exports.fleet = new FleetService();
